import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import { useJob } from '../../state';
import { colors, headerHeight } from '../../constants';
import { Run } from '../run';
import { LeftNav } from '../nav';
import { Loading } from '../loading';
import { PillButtons } from '../input';
import { Args, Progress, ItemsTable, Cost, Artifacts } from '../job';
import { VisitResults } from './VisitResults';
import { Copy } from '../copy';
import { styles } from '../../constants';

const UrlsList = ({ urls }) => (
  <div>
    <div style={styles.stickyHeader}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <div>
          <b>{urls.length}</b> URLs
        </div>
        {urls.length > 0 && <Copy value={urls.join('\n')} onlyCheck />}
      </div>
    </div>

    <div>
      {urls.map((it) => (
        <div>{it}</div>
      ))}
    </div>
  </div>
);

const VisitJob = ({ job, slim }) => {
  const pattern = job?.args?.pattern || '';

  return (
    <div>
      <VisitResults job={job} />
    </div>
  );
};

const CrawlJob = ({ job, slim }) => {
  const pattern = job?.args?.pattern || '';

  return (
    <div>
      <UrlsList urls={job?.results?.hits || []} />
    </div>
  );
};

const ExtractJob = ({ job, slim }) => {
  return (
    <div>
      <ItemsTable items={job.results?.items || []} />
    </div>
  );
};

const ScrapeJob = ({ job, slim }) => {
  return (
    <div>
      <ItemsTable items={job.results?.items || []} />
      <br />
      <UrlsList urls={job?.results?.hits || []} />
    </div>
  );
};

const JsonJob = ({ job }) => (
  <div>
    <pre>{JSON.stringify(job, null, 2)}</pre>
  </div>
);

export const Inner = ({ job, loading, slim }) => {
  const [tab, setTab] = useState('results');

  if (!job) {
    return null;
  }

  const innerFn = {
    visit: VisitJob,
    crawl: CrawlJob,
    extract: ExtractJob,
    scrape: ScrapeJob,
  }[job?.name];

  const inner = (innerFn || JsonJob)({ job, slim });

  const headerNode = (
    <div style={styles.stickyHeader}>
      <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        {!job && <Loading size="xs" />}
        {job && job?.state == 'active' && <Loading size="xs" />}
        {job && job?.state == 'completed' && (
          <div
            style={{
              color: colors.green,
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <FaCheckCircle />
          </div>
        )}
        {job && (
          <div>
            <b>
              {job?.name || 'job'} {job.id}
            </b>
          </div>
        )}
        {job && <div>- {job?.state}</div>}
      </div>
    </div>
  );

  const argsNode = (
    <>
      <Args job={job} onRunAgain={() => setTab('results')} />
    </>
  );

  const costNode = (
    <>
      <Cost job={job} showPercent />
    </>
  );

  const artifactsNode = (
    <>
      {!job.artifacts?.length && <div>No artifacts</div>}
      <Artifacts artifacts={job.artifacts || []} />
    </>
  );

  const choices = [
    ['results', 'Results'],
    ['args', 'Arguments'],
    ['jobs', 'Child Jobs'],
    ['cost', 'Cost'],
    ['artifacts', 'Artifacts'],
  ];

  const childJobs = job?.progress?.children?.jobs || [];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {!slim && headerNode}

      {!slim && <PillButtons value={tab} onChange={setTab} choices={choices} />}

      {tab == 'results' && <Progress job={job} slim />}
      {tab == 'results' && inner}

      {tab == 'args' && argsNode}

      {tab == 'jobs' && childJobs.length == 0 && <div>No child jobs</div>}
      {tab == 'jobs' && childJobs.length > 0 && <Progress job={job} />}

      {tab == 'cost' && costNode}
      {tab == 'artifacts' && artifactsNode}

      {/*
      <pre>JOB:{JSON.stringify(job, null, 2)}</pre>
      */}
    </div>
  );
};

export const Job = ({ id, job, slim }) => {
  const { loading, job: job_ } = useJob(id);

  return <Inner job={job || job_} loading={!job && loading} slim={slim} />;
};
